export default __webpack_public_path__ + "static/media/training@3x.06731eb4.png";